import sha1 from '@republic/foundation/crypto/sha1';
import {any, reduce} from '@republic/foundation/lang/array';
import {stringify} from '@republic/foundation/lang/json';
import {createPrefixed} from '@republic/foundation/storage';
import AuthStream from '../../auth/streams/AuthStream';
import session from '../../core/services/storage/session';
import {createRequestStream} from '../../core/streams';

export default (
    createRequestStream(
        'UnpaidInvoices',
        {
            code: 'account/unpaid-invoices',
            error: 'A request for unpaid invoices failed',
            singleton: true
        },
        createPrefixed(session, 'account/unpaid-invoices/3.0', 15 * 60),
        {auth: AuthStream},
        ({auth}) => (
            auth.id ?
                sha1(
                    stringify({
                        id: auth.id
                    })) :
                null),
        unpaid => !!unpaid.data,
        () => true,
        ({auth}) => (
            auth.roles.rw_customer ?
                fetch(
                    '/fractus/p/stratus/rest/v3/dunning_invoices',
                    {
                        headers: {
                            Authorization: `Bearer ${auth.token}`
                        }
                    }) :
                null),
        raw => ({
            data: {
                unresolved: any(raw ? raw.members : [], ({resolved}) => !resolved),
                pending: any(raw ? raw.members : [], ({pending_retry: pending}) => pending),
                balance: (
                    reduce(
                        raw ? raw.members : [],
                        (total, {resolved, pending_retry: pending, balance}) => (
                            (!resolved && !pending) ?
                                total + (balance || 0) :
                                total),
                        0))
            }
        }),
        () => ({data: undefined})));
